/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
// import auth from '@/auth/authService'
import auth from "./store/auth/moduleAuthState";

// import firebase from "firebase/app";
// import "firebase/auth";
Vue.use(Router);

const router = new Router({
  mode: "history",
  // base: window.location.pathname.substring(0, window.location.pathname.lastIndexOf("/") + 1 ),//process.env.BASE_URL,
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/",
          redirect: "/dashboard/analytics",
        },
        {
          path: "/index.html",
          redirect: "/dashboard/analytics",
        },
        {
          path: "/dashboard/analytics",
          name: "dashboard-analytics",
          component: () => import("./views/DashboardAnalytics.vue"),
          meta: {
            rule: "user",
            authRequired: true,
          },
        },
        // =============================================================================
        // Timekeeping
        // =============================================================================
        {
          path: "/timekeeping/attendancelog",
          name: "attendancelog",
          component: () => import("./views/timekeeping/AttendanceLog.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Timekeeping" },
              { title: "Attendance Log", active: true },
            ],
            pageTitle: "Attendance Log",
            rule: "user",
            authRequired: true,
          },
        },
        {
          path: "/timekeeping/timerequest",
          name: "timerequest",
          component: () => import("./views/timekeeping/TimeRequest.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Timekeeping" },
              { title: "Time Request", active: true },
            ],
            pageTitle: "Time Request",
            rule: "user",
            authRequired: true,
          },
        },
        {
          path: "/selfservice/schedulerequest",
          name: "schedulerequest",
          component: () => import("./views/selfservice/ScheduleRequest.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Self-Service" },
              { title: "Schedule Request", active: true },
            ],
            pageTitle: "Schedule Request",
            rule: "user",
            authRequired: true,
          },
        },
        // =============================================================================
        // Self-Service
        // =============================================================================

        {
          path: "/selfservice/leaverequest",
          name: "leaverequest",
          component: () => import("./views/selfservice/LeaveRequest.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Self-Service" },
              { title: "Leave Request", active: true },
            ],
            pageTitle: "Leave Request",
            rule: "user",
            authRequired: true,
          },
        },
        {
          path: "/selfservice/overtimerequest",
          name: "overtimerequest",
          component: () => import("./views/selfservice/OvertimeRequest.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Self-Service" },
              { title: "Overtime Request", active: true },
            ],
            pageTitle: "Overtime Request",
            rule: "user",
            authRequired: true,
          },
        },
        {
          path: "/selfservice/loanrequest",
          name: "loanrequest",
          component: () => import("./views/selfservice/LoanRequest.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Self-Service" },
              { title: "Loan Request", active: true },
            ],
            pageTitle: "Loan Request",
            rule: "user",
            authRequired: true,
          },
        },
        {
          path: "/selfservice/claimsrequest",
          name: "requestforms",
          component: () => import("./views/selfservice/ClaimsRequest.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Self-Service" },
              { title: "Claims Request", active: true },
            ],
            pageTitle: "Claims Request",
            rule: "user",
            authRequired: true,
          },
        },
        {
          path: "/selfservice/itrrequest",
          name: "itrrequest",
          component: () => import("./views/selfservice/ItrRequest.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Self-Service" },
              { title: "ITR Request", active: true },
            ],
            pageTitle: "ITR Request",
            rule: "user",
            authRequired: true,
          },
        },
        {
          path: "/selfservice/coerequest",
          name: "coerequest",
          component: () => import("./views/selfservice/CoeRequest.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Self-Service" },
              { title: "COE Request", active: true },
            ],
            pageTitle: "COE Request",
            rule: "user",
            authRequired: true,
          },
        },
        // =============================================================================
        // Reports
        // =============================================================================
        {
          path: "/reports/generatedpayslips",
          name: "generatedpayslips",
          component: () => import("./views/reports/GeneratedPayslips.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Reports" },
              { title: "Generated Payslips", active: true },
            ],
            pageTitle: "Generated Payslips",
            rule: "user",
            authRequired: true,
          },
        },
        {
          path: "/reports/financereports",
          name: "financereports",
          component: () => import("./views/reports/FinanceReports.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Reports" },
              { title: "Final Pay Reports", active: true },
            ],
            pageTitle: "Final Pay Reports",
            rule: "user",
            authRequired: true,
          },
        },

        {
          path: "/reports/coe",
          name: "coe",
          component: () => import("./views/reports/COE.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Reports" },
              { title: "Certificate of Employement", active: true },
            ],
            pageTitle: "Certificate of Employement",
            rule: "admin",
            authRequired: true,
          },
        },
        // =============================================================================
        // For Approval
        // =============================================================================
        {
          path: "/approvals/schedule",
          name: "schedule",
          component: () => import("./views/approvals/CreateSchedule.vue"),
          meta: {
            rule: "manager",
            authRequired: true,
          },
        },
        {
          path: "/approvals/create",
          name: "create-schedule",
          component: () => import("./views/approvals/CreateSchedule.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Managers Launch" },
              { title: "Schedule" },
              { title: "Create Schedule", active: true },
            ],
            pageTitle: "Create Schedule",
            rule: "manager",
            authRequired: true,
          },
        },
        {
          path: "/approvals/schedule/view",
          name: "view-schedule",
          component: () =>
            import("./views/approvals/schedule/ViewSchedule.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Managers Launch" },
              { title: "Schedule", url: "/approvals/schedule/view" },
              { title: "View Schedule", active: true },
            ],
            pageTitle: "View Schedule",
            rule: "manager",
            authRequired: true,
          },
        },
        {
          path: "/approvals/pendingapprovals",
          name: "pendingapprovals",
          component: () => import("./views/approvals/PendingApprovals.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Managers Launch" },
              { title: "Pending Approvals", active: true },
            ],
            pageTitle: "Pending Approvals",
            rule: "manager",
          },
        },
        {
          path: "/approvals/hrapproval",
          name: "hrapproval",
          component: () => import("./views/approvals/HrApproval.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Managers Launch" },
              { title: "HR Approvals", active: true },
            ],
            pageTitle: "Hr Approvals",
            rule: "manager",
          },
        },
        {
          path: "/approvals/mypeople",
          name: "mypeople",
          component: () => import("./views/approvals/MyPeople.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Managers Launch" },
              { title: "My People", active: true },
            ],
            pageTitle: "My People",
            rule: "manager",
          },
        },
        // =============================================================================
        // HRIS
        // =============================================================================
        {
          path: "/hris/recruitment",
          name: "recruitment",
          component: () => import("./views/hris/Recruitment.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "HRIS" },
              { title: "Recruitment", active: true },
            ],
            pageTitle: "Recruitment",
            rule: "hr",
          },
        },
        {
          path: "/hris/employeelist",
          name: "employeelist",
          component: () => import("./views/hris/EmployeeList.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "HRIS" },
              { title: "Employee List", active: true },
            ],
            pageTitle: "Employee List",
            rule: "hr",
          },
        },
        // {
        //   path: '/hris/registeremployee',
        //   name: 'registeremployee',
        //   component: () => import('./views/hris/RegisterEmployee.vue'),
        //   meta: {
        //       breadcrumb: [
        //           { title: 'Home', url: '/' },
        //           { title: 'HRIS'},
        //           { title: 'Register Employee', active: true },
        //       ],
        //       pageTitle:'Register Employee',
        //       rule: 'hr'
        //   }
        // },
        {
          path: "/hris/employeeinformation/:id",
          name: "employeeinformation",
          component: () => import("./views/hris/EmployeeInformation.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "HRIS" },
              { title: "Employee Information", active: true },
            ],
            pageTitle: "Employee Information",
            rule: "hr",
          },
        },
        {
          path: "/hris/bulksalaryupload",
          name: "bulksalaryupload",
          component: () => import("./views/hris/BulkSalaryUpload.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "HRIS" },
              { title: "Bulk Salary Upload", active: true },
            ],
            pageTitle: "Bulk Salary Upload",
            rule: "administrator",
          },
        },
        // =============================================================================
        // PAYROLL
        // =============================================================================
        {
          path: "/payroll/createpayroll",
          name: "createpayroll",
          component: () =>
            import("./views/payroll/createpayroll/CreatePayroll.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Payroll" },
              { title: "Create Payroll", active: true },
            ],
            pageTitle: "Create Payroll",
            rule: "payroll",
          },
        },
        {
          path: "/payroll/hoursrendered",
          name: "hoursrendered",
          component: () =>
            import("./views/payroll/hoursrendered/HoursRendered.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Payroll" },
              { title: "Allowances Deductions", active: true },
            ],
            pageTitle: "Allowances Deductions",
            rule: "payroll",
          },
        },
        {
          path: "/payroll/earnings",
          name: "earnings",
          component: () => import("./views/payroll/hoursrendered/Earnings.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Payroll" },
              { title: "Hours Rendered" },
              { title: "Earnings", active: true },
            ],
            pageTitle: "Earnings",
            rule: "payroll",
          },
        },
        {
          path: "/payroll/deductions",
          name: "deductions",
          component: () =>
            import("./views/payroll/hoursrendered/Deductions.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Payroll" },
              { title: "Hours Rendered" },
              { title: "Deductions", active: true },
            ],
            pageTitle: "Deductions",
            rule: "payroll",
          },
        },
        {
          path: "/payroll/loans",
          name: "loans",
          component: () => import("./views/payroll/hoursrendered/Loans.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Payroll" },
              { title: "Hours Rendered" },
              { title: "Loans", active: true },
            ],
            pageTitle: "Loans",
            rule: "payroll",
          },
        },
        {
          path: "/payroll/otherreports",
          name: "otherreports",
          component: () =>
            import("./views/payroll/otherreports/OtherReports.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Payroll" },
              { title: "Other Reports", active: true },
            ],
            pageTitle: "Other Reports",
            rule: "payroll",
            // authorize:['administrator']
          },
        },

        //Year to Date Balance
        {
          path: "/payroll/yeartodatebalance",
          name: "yeartodatebalance",
          component: () =>
            import("./views/payroll/yeartodatebalance/YeartoDateBalance.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Payroll" },
              { title: "Year to Date Balance", active: true },
            ],
            pageTitle: "Year to Date Balance",
            rule: "payroll",
          },
        },

        //PAYROLL SETTINGS
        {
          path: "/payroll/settings",
          name: "settings",
          component: () => import("./views/payroll/Settings.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Payroll" },
              { title: "Settings", active: true },
            ],
            pageTitle: "Settings",
            rule: "payroll",
            // authorize:['administrator']
          },
        },

        // {
        //   path: '/payroll/uploads',
        //   name: 'uploads',
        //   component: () => import('./views/payroll/Uploads.vue'),
        //   meta: {
        //       breadcrumb: [
        //           { title: 'Home', url: '/' },
        //           { title: 'Payroll'},
        //           { title: 'Payroll Uploads', active: true },
        //       ],
        //       pageTitle:'Payroll Uploads',
        //       rule: 'payroll'
        //   }
        // },
        // =============================================================================
        // ADMIN
        // =============================================================================
        {
          path: "/admin/companylist",
          name: "companylist",
          component: () => import("./views/admin/CompanyList.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Admin" },
              { title: "Company List", active: true },
            ],
            pageTitle: "Company List",
            rule: "hr",
          },
        },
        {
          path: "admin/companyinformation/:tenantsId",
          name: "companyinformation",
          component: () => import("./views/admin/CompanyInformation.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Admin" },
              { title: "Company Information", active: true },
            ],
            pageTitle: "Company Information",
            rule: "hr",
          },
        },
        {
          path: "/admin/settings",
          name: "settings",
          component: () => import("./views/admin/Settings.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Admin" },
              { title: "Settings", active: true },
            ],
            pageTitle: "Settings",
            rule: "administrator",
          },
        },
        {
          path: "/admin/masterfileupload",
          name: "masterfileupload",
          component: () => import("./views/admin/MasterfileUpload.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Admin" },
              { title: "MasterFile Upload", active: true },
            ],
            pageTitle: "MasterFile Upload",
            rule: "administrator",
          },
        },
      ],
    },

    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/callback",
          name: "auth-callback",
          component: () => import("@/views/Callback.vue"),
          meta: {
            rule: "user",
          },
        },
        {
          path: "/pages/login",
          name: "page-login",
          component: () => import("@/views/pages/login/Login.vue"),
          meta: {
            rule: "user",
          },
        },
        {
          path: "/pages/forgot-password",
          name: "page-forgot-password",
          component: () => import("@/views/pages/ForgotPassword.vue"),
          meta: {
            rule: "user",
          },
        },
        {
          path: "/pages/reset-password",
          name: "page-reset-password",
          component: () => import("@/views/pages/ResetPassword.vue"),
          meta: {
            rule: "user",
          },
        },
        {
          path: "/pages/change-password/:id",
          name: "page-change-password",
          component: () => import("@/views/pages/ChangePassword.vue"),
          meta: {
            rule: "user",
          },
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue"),
          meta: {
            rule: "user",
          },
        },
        {
          path: "/pages/confirmed",
          name: "page-confirmed",
          component: () => import("@/views/pages/Confirmed.vue"),
          meta: {
            rule: "user",
          },
        },
        {
          path: "/pages/account-success",
          name: "page-account-success",
          component: () => import("@/views/pages/AccountSuccess.vue"),
          meta: {
            rule: "user",
          },
        },
        {
          path: "/pages/account-error",
          name: "page-account-error",
          component: () => import("@/views/pages/AccountError.vue"),
          meta: {
            rule: "user",
          },
        },
        {
          path: "/pages/not-authorized",
          name: "page-not-authorized",
          component: () => import("@/views/pages/NotAuthorized.vue"),
          meta: {
            rule: "user",
          },
        },
        {
          path: "/pages/comingsoon",
          name: "page-coming-soon",
          component: () => import("@/views/pages/ComingSoon.vue"),
          meta: {
            rule: "user",
          },
        },
        {
          path: "/pages/maintenance",
          name: "page-maintenance",
          component: () => import("@/views/pages/Maintenance.vue"),
          meta: {
            rule: "user",
          },
        },
        {
          path: "/pages/approved/:id",
          name: "page-approved",
          component: () => import("@/views/pages/Approved.vue"),
          meta: {
            rule: "user",
          },
        },
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404",
    },
  ],
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});
router.beforeEach((to, _, next) => {
  const isLoggedIn = auth.isUserLoggedIn();

  if (to.matched.some((record) => record.meta.authRequired)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) {
      next({ name: "page-login" });
    } else next();

    // If logged in => not authorized
    // return next({ name: 'page-not-authorized' })
  } else next();
});

export default router;
